import { WarningSolid } from '@wfp/icons-react';
import { Link, Text } from '@wfp/react';
import React from 'react';

interface NoAccessProps {
  variant?: 'role';
}

const NoAccess = ({ variant }: NoAccessProps) => {
  return (
    <main className="not-authorized">
      <WarningSolid
        color="#0a6eb4"
        width="100"
        height="100"
        style={{ marginBottom: '3rem' }}
      />
      <Text kind="h1">No access</Text>
      <br />
      <Text>
        Sorry, you don&apos;t have permission to view this page.
        <br />
        {variant === 'role' ? (
          <p>
            Go back to the <Link href="/">Homepage</Link>
          </p>
        ) : (
          <>
            Please, send an email to{' '}
            <Link href="mailto:hq.spring@wfp.org">hq.spring@wfp.org</Link> to
            request access.
          </>
        )}
      </Text>
    </main>
  );
};

export default NoAccess;
